module.exports = __webpack_public_path__ + "img/bespoke123_20.136fcc1c.jpg";